import React from 'react';
import { Icon, type IIconProps } from './Icon';

export const AngleDoubleDownIcon: React.FC<IIconProps> = (props) => (
  <Icon {...props}>
    <path
      /* eslint-disable max-len */
      d={
        'M270.6 454.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L248 386.7 385.4 249.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L248 194.7 385.4 57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z'
      }
      /* eslint-enable max-len */
    />
  </Icon>
);
